import { match } from 'ts-pattern'

import {
  ShieldFlatIcon,
  WarningFilledIcon,
  WarningTriangleIcon,
} from '@root/shared/ui-kit'

import type { PairAudit, PairMetrics } from '../model'
import type { TransKey } from '@root/shared/localization'
import type { IconProps } from '@root/shared/ui-kit'

export const auditToLabel = (auditRank: PairAudit.AuditStatus): TransKey => {
  return match(auditRank)
    .returnType<TransKey>()
    .with('Danger', () => 'currency.audit.risky')
    .with('Warning', () => 'currency.audit.caution')
    .with('Safe', () => 'currency.audit.safe')
    .exhaustive()
}

export const auditToColor = (auditRank: PairAudit.AuditStatus): string => {
  return match(auditRank)
    .with('Danger', () => 'var(--error-9)')
    .with('Warning', () => 'var(--warning-9)')
    .with('Safe', () => 'var(--success-9)')
    .exhaustive()
}

export const AUDIT_STATUS_ICON_MAP: Record<
  PairAudit.AuditStatus,
  React.FC<IconProps>
> = {
  Danger: WarningTriangleIcon,
  Warning: WarningFilledIcon,
  Safe: ShieldFlatIcon,
}

export const METRIC_SPAN_LABEL_MAP: Record<PairMetrics.MetricsSpan, TransKey> =
  {
    ALL: 'common.period.all',
    '1D': 'common.period.1d',
    '6H': 'common.period.6h',
    '1H': 'common.period.1h',
    '5M': 'common.period.5m',
  }

export { premiumFontCss as premiumTickerFontCss } from '@root/entities/premium/ui'
